//=> Import React
import React from "react";

//=> Styles
const styles = {
  width: "100px",
  height: "2px",
  backgroundColor: "black",
  margin: "20px 0",
}

const Divider = () => <div style={styles} />

export default Divider